import React, { ReactChild, CSSProperties } from 'react';

export const Left: React.FC<{ title: ReactChild; style?: CSSProperties }> = ({
  children,
  title,
  style,
}) => (
  <div
    style={{ gridColumn: 1, wordBreak: 'break-word', ...style }}
    className="p-2"
  >
    <span style={{ fontWeight: 'bold', wordBreak: 'break-word' }}>
      {title}:{' '}
    </span>
    {children}
  </div>
);

export const Right: React.FC<{ title: ReactChild }> = ({ children, title }) => (
  <div style={{ gridColumn: 2 }} className="p-2">
    <span style={{ fontWeight: 'bold' }}>{title}: </span>
    {children}
  </div>
);
